function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n.sidebarclosea{fill:none;stroke:#afafaf;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}\n.sidebarcloseb{fill:#afafaf;}\n"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-978.21 -702.735)"
}, /*#__PURE__*/React.createElement("line", {
  className: "sidebarclosea",
  x1: 25.395,
  transform: "translate(979.21 703.735)"
}), /*#__PURE__*/React.createElement("line", {
  className: "sidebarclosea",
  x1: 12.697,
  transform: "translate(979.211 711.857)"
}), /*#__PURE__*/React.createElement("line", {
  className: "sidebarclosea",
  x1: 12.697,
  transform: "translate(979.211 719.962)"
}), /*#__PURE__*/React.createElement("path", {
  className: "sidebarcloseb",
  d: "M5.168,1.248a1,1,0,0,1,1.664,0l4.131,6.2A1,1,0,0,1,10.131,9H1.869a1,1,0,0,1-.832-1.555Z",
  transform: "translate(1007.71 709.235) rotate(90)"
}));

var SvgSideBarClose = function SvgSideBarClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.5,
    height: 18.5,
    viewBox: "0 0 29.5 18.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSideBarClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sideBarClose.04e0f8dd.svg";
export { ForwardRef as ReactComponent };